import { zClientVehicleDom } from "@/types/client/clientVehicle.domain";
import { zClientVehicleRowDto } from "@/types/client/clientVehicle.dto";
export const ClientVehicleMapper = {
    toDomain(raw) {
        const row = zClientVehicleRowDto.parse(raw);
        return zClientVehicleDom.parse({
            id: row.id,
            clientId: row.idClient,
            brand: row.brand ?? null,
            model: row.model ?? null,
            stateNumber: row.stateNumber ?? null,
            color: row.color ?? null,
            isActive: row.isActive ?? true,
        });
    },
};
